import apiClient from "./apiClient";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

export interface AuditLogSearchParams {
  page: number;
  pageSize: number;
  tableName?: string | null;
  rowId?: string | null;
  userId?: string | null;
  action?: string | null;
  requestId?: string | null;
  from?: string | null;
  to?: string | null;
}

export interface AuditLogEntry {
  id: number;
  occurredAt: string;
  txid: number;
  requestId: string | null;
  userId: string | null;
  userName: string | null;
  actor: string | null;
  ip: string | null;
  action: string;
  tableName: string;
  rowId: string | null;
  changed: string | null;
  reason: string | null;
}

export interface AuditLogPage {
  totalElements: number;
  content: AuditLogEntry[];
}

export async function findAuditLog(params: AuditLogSearchParams): Promise<AuditLogPage> {
  const response = await apiClient.post<AuditLogPage>(`${BASE_URL}/api/v1/audit/list`, params);
  return response.data;
}
